import React, { FC } from 'react';
import { useQuery } from '@apollo/react-hooks';

import { Loader } from '../../../../components/Loader';
import { GET_B2C_LEARNER_SUBSCRIPTION_INFORMATION } from '../../../../graphql/user';
import { Query } from '../../../../types';
import { SubscriptionInfo } from '../SubscriptionInfo';

interface B2CLearnerSubscriptionProps {
  chargeBeeSite?: string;
}

const B2CLearnerSubscription: FC<B2CLearnerSubscriptionProps> = ({ chargeBeeSite }) => {
  const { data, loading } = useQuery<Pick<Query, 'getMySubscriptionB2CLearnerChargebeeInfo'>>(
    GET_B2C_LEARNER_SUBSCRIPTION_INFORMATION,
    {
      fetchPolicy: 'network-only',
    },
  );

  const info = data?.getMySubscriptionB2CLearnerChargebeeInfo;

  if (loading) {
    return <Loader />;
  }

  return <SubscriptionInfo info={info} chargeBeeSite={chargeBeeSite} />;
};

export default B2CLearnerSubscription;
